import { module } from 'modujs';
import { lazyLoadImage } from '../utils/image';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            mouseenter: 'onMouseEnter'
        }
    }

    init() {
        this.isImageLoaded = false;
        this.$alternativeImg = this.$('alternative-image')[0] || false
    }

    onMouseEnter() {
        if(!this.$alternativeImg || window.isMobile || this.isImageLoaded) {
            return
        }

        lazyLoadImage(this.$alternativeImg, null, () => {
            this.isImageLoaded = true
        })
    }

    destroy() {
        super.destroy();
    }
}
